import * as React from 'react'
import { MenuContainerProps, MenuItemProps } from 'piral'
import { useAuth } from '../auth/AuthProvider'

const Navigation: React.FC<MenuContainerProps> = ({ children, type }) => {
  const { user } = useAuth()

  // Menu items render in (non-deterministic) pilet load order by default.
  // Each item carries its registerMenu settings as `meta`, so we sort by the
  // custom `order` field to give pilets control over their position, and drop the
  // ones a pilet marked `secured` while no one is signed in — the item reappears
  // the moment `whoami` resolves to a user, without a reload.
  const items = (React.Children.toArray(children) as Array<React.ReactElement<MenuItemProps>>)
    .filter(item => !item.props.meta?.secured || !!user)
    .sort((a, b) => (a.props.meta?.order ?? 0) - (b.props.meta?.order ?? 0))

  // Each item is the shell's MenuItem (a Focusable-wrapped <a>, see layout.tsx) —
  // wrap it in an <li> so the <ul> is a valid, announceable list rather than links
  // dangling directly in a list. This is the only <li>: MenuItem no longer adds its
  // own, which would have nested <li> in <li>.
  const listItems = items.map((item, index) => <li key={item.key ?? index}>{item}</li>)

  // Piral uses ONE MenuContainer for every menu type. `general` is the main header
  // nav and owns its chrome; every other type is rendered inside something that
  // already provides chrome (the `admin` type lives in the header's kebab panel),
  // so it contributes just the list.
  if (type !== 'general') {
    return <ul className='MenuList'>{listItems}</ul>
  }

  return (
    <div id='navigation' className='Navigation'>
      {/* Named so a screen reader can tell this apart from the kebab menu and the
          header actions when listing landmarks. */}
      <nav aria-label='Main'>
        <ul>{listItems}</ul>
      </nav>
    </div>
  )
}

export default Navigation
